import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthSession } from "@/lib/auth-client";
import { Sidebar } from "@/components/Sidebar";
import { TopBar } from "@/components/TopBar";
import { BottomNav } from "@/components/pwa/BottomNav";
import { PullToRefresh } from "@/components/pwa/PullToRefresh";
import { PageTransition } from "@/components/pwa/PageTransition";
import { Outlet } from "react-router-dom";

export function DashboardLayout() {
  const navigate = useNavigate();
  const { session, isPending } = useAuthSession();

  useEffect(() => {
    if (isPending) return;
    if (!session?.user) {
      navigate("/login", { replace: true });
      return;
    }
    const role = (session.user as { role?: string }).role;
    if (role === "TENANT") {
      navigate("/tenant", { replace: true });
    }
  }, [isPending, session?.user, navigate]);

  if (isPending || !session?.user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-slate-900">
        <div className="flex flex-col items-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-[3px] border-primary-200 border-t-primary-600 dark:border-primary-800 dark:border-t-primary-500" />
          <p className="text-sm text-slate-400 dark:text-slate-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <PullToRefresh>
      <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
        <Sidebar />
        <div className="flex flex-1 flex-col min-w-0">
          <TopBar />
          <main className="flex-1 p-4 pb-24 sm:p-6 lg:pb-6">
            <PageTransition>
              <Outlet />
            </PageTransition>
          </main>
          <footer className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 py-4 px-4 sm:px-6">
            <p className="text-center text-xs text-slate-500 dark:text-slate-400">
              RentMaadi does not process payments. It only records and organizes
              rental information provided by users.
            </p>
          </footer>
        </div>
        <BottomNav />
      </div>
    </PullToRefresh>
  );
}
